import { Skeleton } from 'antd'
import React from 'react'

function Card({className='', loading, ...restProps}) {
  return (
    <div className={`px-6 py-4 rounded-2xl bg-cardbg shadow-md ${className}`} {...restProps}>
    </div>
  )
}

export default Card